import { Divider } from '@mui/material'
import { styled } from '@mui/material/styles'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import T from 'prop-types'
import { addMinutes, subMinutes } from 'date-fns'
import { AGENDA_DATE_END, AGENDA_DATE_START, AGENDA_TASKS } from 'lib/agenda'

import DateTimePicker from 'components/atoms/DateTimePicker'

const GridWrapper = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 2fr',
  columnGap: theme.spacing(3),
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
}))

export default function TaskDatesRow({
  task,
  agenda,
  handleDateChange,
  errors,
  readOnly,
}) {
  const { t } = useTranslation()

  const taskIndex = useMemo(() => AGENDA_TASKS.indexOf(task.task), [task])

  return (
    <div>
      <GridWrapper>
        <div>
          <DateTimePicker
            id={`${task.task}.${AGENDA_DATE_START}`}
            label={
              t(`sessions.planning.${task.task}.${AGENDA_DATE_START}`) +
              t('common.colon')
            }
            handleDateChange={handleDateChange}
            value={
              task.startsAt === null ? task.startsAt : new Date(task.startsAt)
            }
            minDateTime={
              taskIndex === 0
                ? undefined
                : addMinutes(
                    new Date(agenda[AGENDA_TASKS[taskIndex - 1]].endsAt),
                    1
                  )
            }
            maxDateTime={subMinutes(new Date(task.endsAt), 1)}
            error={
              (
                errors.find(
                  (error) => error.id === `${task.task}.${AGENDA_DATE_START}`
                ) || {}
              ).error
            }
            readOnly={readOnly}
          />
        </div>
        <div>
          <DateTimePicker
            id={`${task.task}.${AGENDA_DATE_END}`}
            label={
              t(`sessions.planning.${task.task}.${AGENDA_DATE_END}`) +
              t('common.colon')
            }
            handleDateChange={handleDateChange}
            value={task.endsAt === null ? task.endsAt : new Date(task.endsAt)}
            minDateTime={addMinutes(new Date(task.startsAt), 1)}
            maxDateTime={
              taskIndex === AGENDA_TASKS.length - 1
                ? undefined
                : subMinutes(
                    new Date(agenda[AGENDA_TASKS[taskIndex + 1]].startsAt),
                    1
                  )
            }
            error={
              (
                errors.find(
                  (error) => error.id === `${task.task}.${AGENDA_DATE_END}`
                ) || {}
              ).error
            }
            readOnly={readOnly}
          />
        </div>
      </GridWrapper>
      <Divider light />
    </div>
  )
}

TaskDatesRow.propTypes = {
  task: T.object.isRequired,
  agenda: T.object,
  handleDateChange: T.func,
  errors: T.array.isRequired,
  readOnly: T.bool,
}
